import React from "react";
import Slider from "react-slick";
import Img from "./Img";

const CarasouelImages = ({
  images = [],
  autoPlaySpeed = 3000,
  onClick = () => {},
  isClickable = false,
}) => {
  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: autoPlaySpeed,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    height: "100%",
  };
  // console.log({ carasol: images });
  return (
    // <div>
    <Slider
      {...settings}
      className="grow w-full h-full "
      style={{ height: "100%" }}
    >
      {/* <div> */}
      {images?.map((img, idx) => (
        <div
          key={idx}
          onClick={onClick}
          className={"h-full w-full " + (isClickable ? "cursor-pointer" : "")}
        >
          <Img
            width="100%"
            height="100%"
            src={`${img}`}
            alt={`img-${idx + 1}`}
            objectFit="cover"
            className="h-full w-full object-cover"
          />
          {/* ASDF */}
        </div>
      ))}
      {/* </div> */}
    </Slider>
    // </div>
  );
};

export default CarasouelImages;
